module.exports = __webpack_public_path__ + "static/cucumbers-b129afceafc0843f0d7a67c9b02c3c23.jpg";